<template>
  <div class="side-nav-outer-toolbar">
    <header-toolbar
      :menu-toggle-enabled="true"
      :toggle-menu-func="toggleMenu"
      :breadcrumb="breadcrumb"
    />
    <dx-drawer
      class="layout-body"
      position="before"
      template="menu"
      :opened.sync="menuOpened"
      :opened-state-mode="drawerOptions.menuMode"
      :reveal-mode="drawerOptions.menuRevealMode"
      :min-size="drawerOptions.minMenuSize"
      :shading="drawerOptions.shaderEnabled"
      :close-on-outside-click="drawerOptions.closeOnOutsideClick"
    >
      <dx-scroll-view ref="scrollViewRef" class="with-footer" v-resize:debounce="onResize">
        <slot />
      </dx-scroll-view>
      <!-- eslint-disable vue/no-unused-vars -->
      <side-nav-menu
        slot="menu"
        slot-scope="_"
        class="dx-swatch-additional"
        :compact-mode="!menuOpened"
        :items="aclFilteredMenu"
        @click="handleSideBarClick"
      />
      <!-- eslint-enable -->
    </dx-drawer>
  </div>
</template>

<script>
import DxDrawer from "devextreme-vue/drawer";
import DxScrollView from "devextreme-vue/scroll-view";
import resize from 'vue-resize-directive';

// import getMenuItems from "../app-navigation";
import { menuDescription } from '../menu.js';
import HeaderToolbar from "@/components/header-toolbar";
import SideNavMenu from "@/components/side-nav-menu";

import { AclHandler } from "@/services/acl-handler";
import { MenuHandler } from "@/services/menu-handler";

export default {
  props: {
    isXSmall: Boolean,
    isLarge: Boolean
  },
  components: {
    DxDrawer,
    DxScrollView,
    HeaderToolbar,
    SideNavMenu
  },
  data() {
    return {
      isCloudMode: this.$store.getters.isCloudMode,
      menuOpened: this.isLarge,
      menuTemporaryOpened: false,
      // menuItems: getMenuItems(this.$i18n.messages[this.$store.getters.browserLocale], this.$store.getters.isCloudMode)
    };
  },
  directives: {
    resize,
  },
  computed: {
    appUser() {
      return this.$store.getters.user;
    },
    aclUser() {
      return new AclHandler(this.appUser, this.isCloudMode);
    },
    menuHandler() {
      return new MenuHandler(menuDescription, this.appUser, this.isCloudMode);
    },
    aclFilteredMenu() {
      return this.menuHandler.getMenuAvailableForUser();
    },
    breadcrumb() {
      return this.$store.getters.breadcrumb;
    },
    drawerOptions() {
      const shaderEnabled = !this.isLarge;
      return {
        menuMode: this.isLarge ? "shrink" : "overlap",
        // menuMode: "overlap",
        menuRevealMode: this.isXSmall ? "slide" : "expand",
        //menuRevealMode: "slide",
        minMenuSize: this.isXSmall ? 0 : 60,
        menuOpened: this.isLarge,
        closeOnOutsideClick: shaderEnabled,
        shaderEnabled
      };
    },
    headerMenuTogglerEnabled() {
      return this.isXSmall;
    },
    scrollView() {
      return this.$refs["scrollViewRef"].instance;
    }
  },
  methods: {
    onResize(e) {
      const layoutBody = { width : e.offsetWidth, height : e.offsetHeight };
      this.$store.commit("setLayoutBody", layoutBody);
    },
    toggleMenu(e) {
      const pointerEvent = e.event;
      pointerEvent.stopPropagation();
      if (this.menuOpened) {
        this.menuTemporaryOpened = false;
      }
      this.menuOpened = !this.menuOpened;
    },
    handleSideBarClick() {
      if (this.menuOpened === false) this.menuTemporaryOpened = true;
      this.menuOpened = true;
    },
    handleResize() {
      const layoutBody = { width : this.scrollView.clientWidth(), height : this.scrollView.clientHeight() };
      this.$store.commit("setLayoutBody", layoutBody);
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    const layoutBody = { width : this.scrollView.clientWidth(), height : this.scrollView.clientHeight() };
    this.$store.commit("setLayoutBody", layoutBody);
  },
  watch: {
    isLarge() {
      if (!this.menuTemporaryOpened) {
        this.menuOpened = this.isLarge;
      }
    },
    $route() {
      if (this.menuTemporaryOpened || !this.isLarge) {
        this.menuOpened = false;
        this.menuTemporaryOpened = false;
      }
      this.scrollView.scrollTo(0);
    }
  }
};
</script>

<style lang="scss">
.side-nav-outer-toolbar {
  flex-direction: column;
  display: flex;
  height: 100%;
  width: 100%;
}

.layout-body {
  flex: 1;
  min-height: 0;
  z-index: 1;
}
</style>
